export default __webpack_public_path__ + "static/media/check.e74dc22a.svg";